export interface RegistrationContext {
    surveySessionToken?: string | number;
}

export const STARTER_PROFILE_PATH = "/konto/profil-startowy";
export const GENERATOR_PATH = "/generator/wyczaruj-stylizacje";

export function getRegistrationDestination(context?: RegistrationContext): string {
    return context?.surveySessionToken ? GENERATOR_PATH : STARTER_PROFILE_PATH;
}
